import { Material, MaterialProperties } from '../../core/Material';
import * as THREE from 'three';

export interface StandardMaterialProperties extends MaterialProperties {
  color: string;
  roughness: number;
  metalness: number;
}

const properties: StandardMaterialProperties = {
  color: '#ffffff',
  roughness: 0.5,
  metalness: 0.5,
};

export const StandardMaterialItem: Material = {
  id: '',
  name: 'Standard Material',
  type: 'material',
  subtype: 'standard',
  properties: properties,
  fields: [
    {
      key: 'properties.color',
      type: 'color',
      label: 'Color',
      default: '#ffffff',
      panel: 'material',
    },
    {
      key: 'properties.roughness',
      type: 'number',
      label: 'Roughness',
      default: 0.5,
      min: 0,
      max: 1,
      step: 0.01,
      panel: 'material',
    },
    {
      key: 'properties.metalness',
      type: 'number',
      label: 'Metalness',
      default: 0.5,
      min: 0,
      max: 1,
      step: 0.01,
      panel: 'material',
    },
  ],
  render: (props) => {
    const { color, roughness, metalness } = props;
    return new THREE.MeshStandardMaterial({ color, roughness, metalness });
  },
}; 